<template>
  <div class="content-page">
    <div class="hd">
      <el-radio-group v-model="timeTabs" size="mini">
        <el-radio-button
          v-for="item in pickerOptions.shortcuts"
          :key="item.text"
          :label="item.value"
          >{{ item.text }}</el-radio-button
        >
      </el-radio-group>
      <el-date-picker
        size="mini"
        v-model="orderTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="orderTimeChange"
      >
      </el-date-picker>
    </div>
    <div class="bd">
      <div class="row">
        <div class="item">
          <div class="info">
            <p class="title">总营业额</p>
            <strong class="num">{{
              totalRetailPrice ? totalRetailPrice.toFixed(2) : 0
            }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">实收金额（总营业额-退款-优惠）</p>
            <strong class="num">{{ totalMoney ? totalMoney.toFixed(2) : 0 }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">退款金额</p>
            <strong class="num"
              >{{ refundMoney ? refundMoney.toFixed(2) : 0 }}（{{ refundNum }}笔）</strong
            >
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">优惠金额</p>
            <strong class="num">{{
              promotionPrice ? promotionPrice.toFixed(2) : 0
            }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">订单量（不包含退款）</p>
            <strong class="num">{{ totalOrderNum }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">客单价（实收÷订单量）</p>
            <strong class="num">{{ avgPrice ? avgPrice.toFixed(2) : 0 }}</strong>
          </div>
        </div>
      </div>
      <div class="overview">
        <div class="title">收款概况</div>
        <div class="row">
          <div class="item">
            <div class="info">
              <p class="title">微信支付</p>
              <strong class="num">{{ payByWechat ? payByWechat.toFixed(2) : 0 }}</strong>
            </div>
          </div>
          <div class="item">
            <div class="info">
              <p class="title">支付宝支付</p>
              <strong class="num">{{ payByAlipay ? payByAlipay.toFixed(2) : 0 }}</strong>
            </div>
          </div>
          <div class="item">
            <div class="info">
              <p class="title">会员支付</p>
              <strong class="num">{{ payByMember ? payByMember.toFixed(2) : 0 }}</strong>
            </div>
          </div>
          <div class="item">
            <div class="info">
              <p class="title">现金支付</p>
              <strong class="num">{{ payByCash ? payByCash.toFixed(2) : 0 }}</strong>
            </div>
          </div>
          <div class="item">
            <div class="info">
              <p class="title">抖音记账</p>
              <strong class="num">{{ payByDy ? payByDy.toFixed(2) : 0 }}</strong>
            </div>
          </div>
          <div class="item">
            <div class="info">
              <p class="title">美团记账</p>
              <strong class="num">{{ payByMt ? payByMt.toFixed(2) : 0 }}</strong>
            </div>
          </div>
          <div class="item">
            <div class="info">
              <p class="title">其他平台记账</p>
              <strong class="num">{{ payByOther ? payByOther.toFixed(2) : 0 }}</strong>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="tab-header">
                <div class="top">
                    <div class="top-item">
                        <span>数据类型</span>
                        <el-select v-model="dataStatus" placeholder="请选择" size="small">
                            <el-option
                                v-for="item in dataStatusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="top-item">
                        <span>时间选择</span>
                        <el-date-picker
                            v-model="orderTime"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            size="small"
                        ></el-date-picker>
                    </div>
                    <div class="top-item">
                        <el-button type="primary" size="small" @click="getStatisticsOrdersByDate">筛选</el-button>
                        <el-button size="small" @click="resetScreenData">重置</el-button>
                    </div>
                </div>
            </div> -->
      <div class="tab-content">
        <el-radio-group v-model="dataStatus" size="mini" style="margin: 30px 0 10px 20px">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="5">堂食</el-radio-button>
          <el-radio-button label="3">外卖</el-radio-button>
        </el-radio-group>
        <div class="content-container">
          <e-charts class="e-charts" :options="EChartsData"></e-charts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/title"; //引入标题组件
import "echarts/lib/component/legend"; //引入图例组件
import "echarts/lib/component/tooltip"; //引入图例组件
import {
  getStatisticsOrders,
  getStatisticsOrdersToday,
  getStatisticsOrdersByDate,
} from "@/api/index.js";
export default {
  components: {
    ECharts,
  },

  data() {
    return {
      EChartsData: {
        grid: {
          top: "82px",
          left: "58px",
          right: "48px",
        },
        title: {
          text: "每天营业额/订单量",
          textStyle: {
            color: "#333333",
            fontWeight: "bold",
            fontSize: 12,
          },
          top: "32px",
          left: "65px",
        },
        tooltip: {
          trigger: "axis",
          formatter: function (a) {
            let list = [a[0].axisValueLabel];
            let listItem = "";
            for (var i = 0; i < a.length; i++) {
              list.push(
                '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
                  a[i].color +
                  ';margin-right: 5px;border-radius: 50%;}"></i><span style="width:auto; display:inline-block;">' +
                  a[i].seriesName +
                  "</span>：" +
                  a[i].value
              );
            }
            listItem = list.join("<br>");
            return '<div class="showBox">' + listItem + "</div>";
          },
        },
        legend: {
          data: ["营业额", "订单量"],
          textStyle: {
            color: "#333333",
            fontWeight: "bolder",
          },
          top: "32px",
          left: "208px",
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          nameTextStyle: {
            color: "#747480",
            fontSize: 14,
          },
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "营业额",
            type: "line",
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: "#f68080",
              },
            },
            data: [],
          },
          {
            name: "订单量",
            type: "line",
            smooth: true,
            lineStyle: {
              normal: {
                width: 3,
                color: "#267afc",
              },
            },
            data: [],
          },
        ],
        animationDuration: 2000,
      },
      avgPrice: 0,
      totalRetailPrice: 0,
      totalMoney: 0,
      refundMoney: 0,
      refundNum: 0,
      promotionPrice: 0,
      totalOrderNum: 0,
      payByAlipay: 0,
      payByCash: 0,
      payByDy: 0,
      payByMt: 0,
      payByOther: 0,
      payByMember: 0,
      payByWechat: 0,
      dataStatus: "",
      dataStatusOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "5",
          label: "堂食",
        },
        {
          value: "3",
          label: "外卖",
        },
      ],
      orderTime: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date()],
      timeTabs: "week",
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            value: "today",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近7日",
            value: "week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30日",
            value: "month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近90日",
            value: "quarter",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dates: [],
    };
  },

  watch: {
    dataStatus() {
      this.getStatisticsOrdersByDate();
    },
    timeTabs(value) {
      const end = new Date();
      const start = new Date();
      if (value == "today") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
        this.orderTime = [start, end];
      }
      if (value == "week") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        this.orderTime = [start, end];
      }
      if (value == "month") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
        this.orderTime = [start, end];
      }
      if (value == "quarter") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
        this.orderTime = [start, end];
      }
      this.getStatisticsOrdersByDate();
    },
  },

  mounted() {
    this.getStatisticsOrdersByDate();
  },

  methods: {
    resetScreenData() {
      this.dataStatus = "";
      this.orderTime = [];
    },
    async getData() {
      let begin = new Date(this.orderTime[0]).pattern("yyyy-MM-dd");
      let end = new Date(this.orderTime[1]).pattern("yyyy-MM-dd");
      await getStatisticsOrders({
        startDate: this.orderTime[0]
          ? new Date(this.orderTime[0]).pattern("yyyy-MM-dd")
          : "",
        endDate: this.orderTime[1]
          ? new Date(this.orderTime[1]).pattern("yyyy-MM-dd")
          : "",
        orderCategory: this.dataStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.payByAlipay = res.data.payByAlipay;
          this.payByMember = res.data.payByMember;
          this.payByWechat = res.data.payByWechat;
          this.payByCash = res.data.payByCash;
          this.payByDy = res.data.payByDy;
          this.payByMt = res.data.payByMt;
          this.payByOther = res.data.payByOther;
          this.totalRetailPrice = res.data.totalRetailPrice;
          this.totalMoney = res.data.money;
          this.refundMoney = res.data.refundMoney;
          this.refundNum = res.data.refundNum;
          this.promotionPrice = res.data.promotionPrice;
          this.totalOrderNum = res.data.orderNum;
          this.avgPrice = res.data.avgPrice;
        } else {
          this.payByAlipay = 0;
          this.payByMember = 0;
          this.payByWechat = 0;
          this.payByCash = 0;
          this.payByDy = 0;
          this.payByMt = 0;
          this.payByOther = 0;
          this.totalRetailPrice = 0;
          this.totalMoney = 0;
          this.refundMoney = 0;
          this.refundNum = 0;
          this.promotionPrice = 0;
          this.totalOrderNum = 0;
          this.avgPrice = 0;
        }
      });
      // await getStatisticsOrdersToday().then(res => {
      //     if (res.code == 1) {
      //         this.todayMoney = res.data.money;
      //         this.todayOrderNum = res.data.orderNum;
      //     }
      // });
    },
    getStatisticsOrdersByDate() {
      this.getData();
      let begin = new Date(this.orderTime[0]).pattern("yyyy-MM-dd");
      let end = new Date(this.orderTime[1]).pattern("yyyy-MM-dd");
      this.dates = this.getAll(begin, end);
      this.EChartsData.series[0].data = Array(this.dates.length).fill(0);
      this.EChartsData.series[1].data = Array(this.dates.length).fill(0);
      getStatisticsOrdersByDate({
        startDate: this.orderTime[0]
          ? new Date(this.orderTime[0]).pattern("yyyy-MM-dd")
          : "",
        endDate: this.orderTime[1]
          ? new Date(this.orderTime[1]).pattern("yyyy-MM-dd")
          : "",
        orderCategory: this.dataStatus,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            this.EChartsData.series[0].data[this.dates.indexOf(val.orderDate)] =
              val.money;
            this.EChartsData.series[1].data[this.dates.indexOf(val.orderDate)] =
              val.orderNum;
          });
          this.EChartsData.xAxis.data = this.dates;
          this.EChartsData = this.EChartsData;
        } else {
          this.EChartsData.xAxis.data = [];
          this.EChartsData.series[0].data = [];
          this.EChartsData.series[1].data = [];
          this.EChartsData = this.EChartsData;
          if (res.code == -1) {
            this.$notify({
              title: "提示",
              message: "暂无更多数据",
              type: "error",
              duration: 2000,
            });
            return;
          }
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getAll(begin, end) {
      var arr = [];
      var ab = begin.split("-");
      var ae = end.split("-");
      var db = new Date();
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
      var de = new Date();
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
      var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
      var unixDe = de.getTime() - 24 * 60 * 60 * 1000;
      for (var k = unixDb; k <= unixDe; ) {
        //console.log((new Date(parseInt(k))).format());
        k = k + 24 * 60 * 60 * 1000;
        arr.push(new Date(parseInt(k)).format());
      }
      //console.log(JSON.stringify(arr));
      return arr;
    },
    orderTimeChange(e) {
      this.getStatisticsOrdersByDate();
      this.timeTabs = "";
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: hidden;
  .hd {
    padding: 20px 0 0 20px;
    .el-radio-group {
      margin-right: 10px;
    }
  }
  .bd {
    height: 100%;
  }
  .icon {
    text-align: center;
    color: #fff;
    &.circle {
      width: 45px;
      height: 45px;
      line-height: 45px;
      border-radius: 50%;
      &.iconfont {
        font-size: 22px;
      }
    }
    &.rect {
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      &.iconfont {
        font-size: 12px;
      }
    }
    &.blue {
      background: #409eff;
    }
    &.red {
      background: #f56c6c;
    }
    &.green {
      background: #67c23a;
    }
    &.yellow {
      background: #ffa51e;
    }
  }
  .overview {
    & > .title {
      padding-left: 20px;
      font-size: 22px;
      font-weight: 600;
    }
  }
  .row {
    display: flex;
    .item {
      flex: 1;
      display: flex;
      padding-left: 20px;
      margin: 37px 0 39px;
      cursor: default;
      .info {
        // margin-left: 18px;
        .title {
          font-size: 12px;
          line-height: 12px;
          color: #666666;
          margin-top: 2px;
          margin-bottom: 10px;
          .el-link {
            margin-left: 10px;
            font-size: 12px;
            vertical-align: inherit;
          }
        }
        .num {
          font-size: 18px;
          line-height: 18px;
          color: #333333;
        }
      }
    }
  }
  .tab-header {
    height: 72px;
    line-height: 42px;
    box-sizing: border-box;
    border-bottom: 0;
    .top {
      display: flex;
      margin-bottom: 20px;
      white-space: nowrap;
      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;
        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .tab-content {
    display: block;
    padding: 0;
    height: calc(100% - 124px);
  }
}
</style>

<style lang="less">
.right {
  .el-progress__text {
    color: #e99322;
  }
}
.echarts,
.e-charts {
  width: 100%;
}
</style>
